import React, { useState } from "react";
import { observer } from "mobx-react";
import { FiType } from "react-icons/fi";
import PlaylistsStore from "../../../../stores/PlaylistsStore";
import { Spinner, Input, Button, MultiSelect } from "../../../-common";
import "./AddPlaylistModal.scss";

const getTrackLabel = ({ value }) => value?.order + " - " + value?.title;

function AddPlaylistModal({ album, close }) {
  const { id: albumId, tracks: availableTracks } = album || {};

  const [adding, setAdding] = useState(false);

  const [name, setName] = useState();
  const updateName = ({ target }) => setName(target?.value);

  const [tracks, setTracks] = useState([]);
  const updateTracks = tracks => setTracks(tracks?.map(t => t?.id));
  const selectedTracks = tracks?.map(tid => availableTracks?.find(t => t?.id === tid))?.filter(Boolean);

  const addEnabled = !!name;
  const addPlaylist = async () => {
    if (addEnabled) {
      setAdding(true);
      await PlaylistsStore.addPlaylist({ albumId, name, tracks });
      setAdding(false);
      close();
    }
  };

  const cancelButtonStyles = adding ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = addEnabled
    ? adding
      ? { opacity: 0.3, pointerEvents: "none" }
      : {}
    : { opacity: 0.3, pointerEvents: "none" };
  const actionButtonContent = adding ? <Spinner /> : "Add Playlist";

  return (
    <div className="add-playlist-modal">
      <div className="content">
        <div className="title">Add Playlist</div>
        <div className="main-content-wrapper">
          <div className="section-container">
            <div className="section-title">Name</div>
            <Input icon={FiType} placeholder="Playlist Name" value={name} onChange={updateName} />
          </div>
          <div className="section-container">
            <div className="section-title">Tracks</div>
            <MultiSelect
              placeholder="Select Tracks"
              options={availableTracks}
              value={selectedTracks}
              onChange={updateTracks}
              formatOptionLabel={getTrackLabel}
            />
          </div>
        </div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">
          <Button type="primary" action={addPlaylist} style={actionButtonStyles}>
            {actionButtonContent}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default observer(AddPlaylistModal);
